import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import { RaaRoles, sessionUserHasRolePrivileges } from '../../../utility/SecurityRules';
import { subscriptionPropType } from '../../../redux/slices/sessionSlice';

/* istanbul ignore next */
// eslint-disable-next-line react/prop-types
const genericDropdownToggle = React.forwardRef(({ children, onClick }, ref) => (
  <div
    href=""
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    ref={ref}
    style={{ cursor: 'pointer' }}
  >
    {children}
  </div>
));

const SubscriptionSelectDropDown = React.memo(({
  activeSubscription,
  onActiveSubscriptionChange,
  userAssignmentList,
}) => (
  <div className="subscription-selection">
    <Dropdown>
      <Dropdown.Toggle as={genericDropdownToggle} id="account-selector">
        <div className="subscription-selection-text">
          <div className="overflow-hidden">
            <div className="subscription-name">
              {activeSubscription.name}
            </div>
            <Icon className="arrow fa-fw dropdown-arrow" icon="caret-down" />
          </div>
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu align="right">
        {sessionUserHasRolePrivileges(
          activeSubscription,
          [RaaRoles.ADMIN, RaaRoles.PROVISIONER, RaaRoles.BILLING],
        ) && (
        <>
          <Dropdown.Item href="/s/subscription/billing">
            <Icon icon="home" />
            {' '}
            Manage Account
          </Dropdown.Item>
          <Dropdown.Divider />
        </>
        )}
        {sessionUserHasRolePrivileges(
          activeSubscription,
          [RaaRoles.MANAGER],
        ) && (
        <>
          <Dropdown.Item href="/s/subscription/sms">
            <Icon icon="home" />
            {' '}
            Manage Account
          </Dropdown.Item>
          <Dropdown.Divider />
        </>
        )}
        {userAssignmentList && userAssignmentList.map((userAssignment) => (
          <Dropdown.Item
            className={userAssignment.id === activeSubscription.id && 'active'}
            onClick={() => onActiveSubscriptionChange(userAssignment.id)}
            key={userAssignment.id}
          >
            {userAssignment.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  </div>
));

SubscriptionSelectDropDown.propTypes = {
  onActiveSubscriptionChange: PropTypes.func.isRequired,
  activeSubscription: subscriptionPropType.isRequired,
  userAssignmentList: PropTypes.arrayOf(subscriptionPropType.isRequired).isRequired,
};

export default SubscriptionSelectDropDown;
